import { Box, Divider } from "@mui/joy";
import { Outlet } from "react-router-dom";

import { ProjectProvider, TaskProvider } from "../provider";
import { AnimationWrapper, FeedbackWidget, Header, NavigationPanel } from "../components";

export default function PostAuthentication() {
    return (
        <Box sx={{ height: "100%", display: "flex" }}>
            <NavigationPanel />
            <Divider orientation={"vertical"} />
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", maxHeight: "100vh" }}>
                <Header />
                <Box
                    sx={{
                        flex: 1,
                        overflow: "auto",
                        minHeight: 0,
                        display: "flex",
                        position: "relative",
                        // flexDirection: "column",
                    }}
                >
                    <ProjectProvider>
                        <TaskProvider>
                            <AnimationWrapper>
                                <Outlet />
                            </AnimationWrapper>
                        </TaskProvider>
                    </ProjectProvider>
                </Box>
            </Box>

            {/* <FeedbackWidget /> */}
        </Box>
    );
}
